export default __webpack_public_path__ + "static/media/property_118.51e07b76.png";